import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<{
  isCurrent?: boolean;
  isLow?: boolean;
  isRanOut?: boolean;
}> = ({ isCurrent, isLow, isRanOut }) => ({
  background: isRanOut
    ? (p) => p.palette.error[50]
    : isLow
    ? (p) => p.palette.warning[50]
    : isCurrent
    ? (p) => p.palette.primary[50]
    : (p) => p.palette.warning[50],
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: isLow
    ? (p) => p.palette.warning[200]
    : isCurrent
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.warning[600],

  borderRadius: (p) => p.spacing(0.625),
  p: (p) => p.spacing(1),
});

export const title: SxStyleFunc<{
  isCurrent?: boolean;
  isLow?: boolean;
  isRanOut?: boolean;
}> = ({ isCurrent, isLow, isRanOut }) => ({
  color: isRanOut
    ? (p) => p.palette.error[500]
    : isLow
    ? (p) => p.palette.warning[500]
    : isCurrent
    ? (p) => p.palette.primary[400]
    : (p) => p.palette.warning[700],
});

export const amount: SxStyleFunc<{
  isCurrent?: boolean;
  isLow?: boolean;
  isRanOut?: boolean;
}> = ({ isCurrent, isLow, isRanOut }) => ({
  color: isRanOut
    ? (p) => p.palette.error[700]
    : isLow
    ? (p) => p.palette.warning[700]
    : isCurrent
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.warning[700],
});

export const upcoming: SxStyleFunc<{
  isCurrent?: boolean;
  isLow?: boolean;
  isRanOut?: boolean;
}> = ({ isCurrent, isLow, isRanOut }) => ({
  fontSize: (p) => p.typography.body4.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
  color: isCurrent
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.warning[600],
});
